// extracted by mini-css-extract-plugin
export default {"row":"Limit_row_OJcx5","usedRow":"Limit_usedRow__v7bB Limit_row_OJcx5","usedKey":"Limit_usedKey_Mj06J","usedValue":"Limit_usedValue_uYd7e","progress":"Limit_progress_XGvtn"};